import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';

export const getMoneyBookList = createAsyncThunk(
	'/moneyBook/getMoneyBookList',
	async (params: any) => {
		const res = await baseuri.get('/admin/master/money_book', {
			params: { ...params },
		});

		return res.data.data;
	}
);

export const getSingleMoneyBook = createAsyncThunk(
	'/moneyBook/getSingleMoneyBook',
	async (params: any) => {
		const res = await baseuri.get(`/admin/master/money_book/manage`, {
			params: { ...params },
		});

		return res.data.data;
	}
);

export const createMoneyBook = createAsyncThunk(
	'moneyBook/createMoneyBook',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/master/sender/create/money_book',
				data
			);

			message.success('Money book created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const doNotPayUser = createAsyncThunk(
	'moneyBook/doNotPayUser',
	async (data: any) => {
		try {
			const res = await baseuri.put(
				`/admin/master/sender/do/not/pay/${data?.listId}`,
				data
			);

			message.success('Action completed!');
			return res.data.data;
		} catch (e: any) {
			// console.log('e', e);
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const importUserList = createAsyncThunk(
	'moneyBook/importUserList',
	async ({ payload, params }: { params: any; payload: any }) => {
		try {
			const res = await baseuri.post(
				`/admin/master/sender/import/user/list`,
				payload,
				{
					params: { ...params },
				}
			);
			message.success('User list updated successfully');
			return res.data.data;
		} catch (e: any) {
			// console.log('e', e);
			message.error(e.response.data.message);
			return false;
		}
	}
);

const moneyBookRx = createSlice({
	name: 'moneyBook',
	initialState: {
		moneyBookList: {
			currencies: [],
			BulkSenderMoneyBook: [],
		},
		singleMoneyBook: {
			moneyBooks: [],
			pagination: {
				currentPage: 0,
				itemsPerPage: 0,
				totalItems: 0,
				totalPages: 0,
			},
			profile: {
				_id: '',
				title: '',
				status: '',
				funder: { title: '', email: '' },
				currency: {
					name: '',
					symbol: '',
					_id: '',
				},
			},
			total_amount: 0,
			total_user: 0,
			total_payable_users: 0,
			total_payable_amount: 0,
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(getMoneyBookList.fulfilled, (store, action) => {
				const state = store;
				state.moneyBookList = action.payload;
			})
			.addCase(getSingleMoneyBook.fulfilled, (store, action) => {
				const state = store;
				state.singleMoneyBook = action.payload;
			}),
});

export default moneyBookRx.reducer;
